<template>
  <div class="intelligent-factory">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/intelligent-factory/banner.jpg" />
    </div>
    <div class="advantage-introduction">
      <div class="website-container">
        <Row>
          <Col class="advantage-image">
          <img src="@/assets/images/website/solution/intelligent-factory/content_1.png" />
          <Row>
            <Col class="advantage-image-item" span="8">
            <div class="ivu-row ivu-row-middle">
              <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
              <span>
                运营成本降低约
                <strong>5-10%</strong>
              </span>
            </div>
            <div class="ivu-row ivu-row-middle">
              <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
              <span>
                产品研制周期缩短约
                <strong>20%</strong>
              </span>
            </div>
            <div class="ivu-row ivu-row-middle">
              <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
              <span>
                能源利用率提高
                <strong>6-8%</strong>
              </span>
            </div>
            </Col>
            <Col class="advantage-image-item" span="8">
            <div class="ivu-row ivu-row-middle">
              <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
              <span>
                产品不良品率降低约
                <strong>2%</strong>
              </span>
            </div>
            </Col>
            <Col class="advantage-image-item" span="8">
            <div class="ivu-row ivu-row-middle">
              <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
              <span>
                物料流转周期缩短约
                <strong>30%</strong>
              </span>
            </div>
            <div class="ivu-row ivu-row-middle">
              <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
              <span>
                人均生产效率提高约
                <strong>20%</strong>
              </span>
            </div>
            </Col>
          </Row>
          </Col>
          <Col class="advantage-list">
          <h3>专业的顶层设计优势&专业的实施优势</h3>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>国家有色工业十三五规划中有色加工智能制造的编写单位；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>中铝公司铝加工智能制造发展规划的编写单位；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>承担国家工信部有色金属深加工智能制造研究课题；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>为主成功协助申报有色加工的国家智能制造新模式课题；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>国家铝/铜加工大数据重点专项申报主要单位；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>具有本行业专业的物流设计与优化的经验与基础；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>具有实现有色加工智能化关键基础的智能装备+智能控制的重要经验；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <span style="padding-left:12px;">板带质量检测、装备改进、AFC、AGC、数据采集、L2级、MES等）</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>具有多台套有色加工自动化装置及全套控制系统改造提质增效案例；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>具有几十项底层数据采集、质量在线检测仪表成功开发实施案例；</span>
          </div>
          <div class="advantage-list-item ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <span>具有近20台套L2级过程控制及4套MES实施经验案例。</span>
          </div>
          </Col>
        </Row>
      </div>
    </div>
    <div class="document-author">
      <div class="website-container">
        <h2>《有色金属行业智能加工工厂建设指南》-主编单位</h2>
      </div>
      <div class="website-container document-content-wrap">
        <div class="document-content ivu-row ivu-row-space-around">
          <img src="@/assets/images/website/solution/intelligent-factory/content_2.png" />
          <img src="@/assets/images/website/solution/intelligent-factory/content_3.png" />
        </div>
      </div>
    </div>
    <div class="factory-framework">
      <div class="website-container">
        <h2>有色金属加工智能工厂的技术架构图</h2>
      </div>
      <div class="website-container">
        <div class="framework-image">
          <img src="@/assets/images/website/solution/intelligent-factory/content_4.png" />
        </div>
      </div>
    </div>
    <div class="scheme-partner">
      <div class="website-container">
        <h2>与中南大学自动化学院、宁波金田、中国联通（洛阳）、安徽鑫科等智能制造战略合作</h2>
      </div>
      <div class="website-container scheme-partner-wrap">
        <div class="partner-content ivu-row ivu-row-space-around">
          <img src="@/assets/images/website/solution/intelligent-factory/content_5.png" />
          <img src="@/assets/images/website/solution/intelligent-factory/content_6.png" />
          <img src="@/assets/images/website/solution/intelligent-factory/content_7.png" />
          <img src="@/assets/images/website/solution/intelligent-factory/content_8.png" />
        </div>
      </div>
    </div>
    <div class="factory-future">
      <div class="website-container">
        <Row>
          <Col class="future-image">
          <img src="@/assets/images/website/solution/intelligent-factory/content_9.png" />
          </Col>
          <Col class="future-scheme">
          <div class="ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <h2>可研阶段的智能规划</h2>
          </div>
          <div class="ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <h2>实施阶段的整体设计</h2>
          </div>
          <div class="ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <h2>落地执行阶段的服务</h2>
          </div>
          <div class="ivu-row ivu-row-middle">
            <img src="@/assets/images/website/solution/intelligent-factory/dot.png" />
            <h2>特定功能定制化开发</h2>
          </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang='less' scoped>
.solution-banner {
  width: 100%;

  img {
    display: block;
    width: 100%;
    object-fit: cover;
  }
}

.advantage-introduction {
  margin-top: 30px;
  margin-bottom: 30px;

  .advantage-image {
    .advantage-image-item {
      padding-left: 10px;

      .ivu-row-middle {
        line-height: 40px;

        img {
          padding-right: 6px;
        }

        span {
          strong {
            color: red;
          }
        }
      }
    }

    .advantage-image-item:first-child {
      padding-left: 0;
    }
  }

  .advantage-list {
    padding-left: 60px;

    h3 {
      padding: 5px 16px;
      margin-bottom: 10px;
      color: #fff;
      background-color: #3a7ec3;
    }

    .advantage-list-item {
      line-height: 28px;

      img {
        padding-right: 6px;
      }
    }
  }
}

.document-author {
  background-color: #fafafb;
  padding: 30px 0 0;

  h2 {
    padding-bottom: 20px;
  }

  .document-content-wrap {
    padding: 50px 100px;
    background-color: #f4faff;

    .document-content {
      background-color: #e8f5ff;
      padding: 50px 0;
    }
  }
}

.factory-framework {
  padding: 30px 0;

  h2 {
    padding-bottom: 20px;
  }

  .framework-image {
    width: 941px;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }
}

.scheme-partner {
  background-color: #fafafb;
  padding: 30px 0 0;

  h2 {
    padding-bottom: 20px;
  }

  .scheme-partner-wrap {
    padding: 50px 100px;
    background-color: #f4faff;

    .partner-content {
      background-color: #e8f5ff;
      padding: 50px 0;
    }
  }
}

.factory-future {
  padding: 30px 0;

  .future-image {
    height: 504px;
  }

  .future-scheme {
    margin-left: 30px;
    background-color: #e8f5ff;
    padding: 100px 124px;

    .ivu-row {
      line-height: 76px;
    }
  }
}
</style>
